"use client";

// src/components/atoms/Tag/Tag.styles.ts
import { tv } from "tailwind-variants";
var tag = tv(
  {
    base: "p-8 text-14 rounded-8 max-w-max",
    variants: {
      color: {
        red: "bg-red-300 text-display-0",
        blue: "bg-blue-500 text-display-0",
        green: "bg-newTon-800 text-display-0"
      },
      direction: {
        left: "rounded-bl-none",
        right: "rounded-br-none"
      }
    },
    defaultVariants: {
      color: "red",
      direction: "right"
    }
  },
  {
    twMerge: false
  }
);

export {
  tag
};
